// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TD0xI{position:fixed;top:0;left:0;right:0;bottom:0;z-index:100;display:flex;align-items:center;justify-content:center;padding:64px;overflow:hidden;background:radial-gradient(circle at 0% 0%, rgba(44, 241, 255, 0.12) 0%, transparent 50%),radial-gradient(circle at 100% 100%, rgba(195, 179, 252, 0.15) 0%, transparent 55%),linear-gradient(135deg, rgba(255, 139, 181, 0) 0%, rgba(210, 198, 253, 0.4) 49%, rgba(244, 236, 255, 0.8) 100%),linear-gradient(-90deg, #ebf1ff 0%, #eeeefd 100%)}.TD0xI.GiXMJ{padding:32px}.TD0xI.n8EiW{padding:0;background:#fff}.xe9XV{width:100%;height:100%;background:#fff;border-radius:16px;overflow:hidden}.n8EiW .xe9XV{border:none;border-radius:0;box-shadow:none}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `TD0xI`,
	"tablet": `GiXMJ`,
	"mobile": `n8EiW`,
	"card": `xe9XV`
};
export default ___CSS_LOADER_EXPORT___;
